import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import Config from './Config'
import SharedStore from './SharedStore'
import Dialog from './Dialog'
import Modal from './Modal'

//import Buefy from 'buefy'
import './assets/custom.scss'
//Vue.use(Buefy)

import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

import VueMeta from 'vue-meta'
Vue.use(VueMeta)

/* const setNormalVH = () => {
  let vh = window.innerHeight * 0.01
  document.documentElement.style.setProperty('--vh', `${vh}px`)

  window.addEventListener('resize', () => {
    let vh = window.innerHeight * 0.01
    document.documentElement.style.setProperty('--vh', `${vh}px`)
  })
}

const setKeyboardVH = () => {
  let vh = window.outerHeight * 0.01
  document.documentElement.style.setProperty('--vh', `${vh}px`)

  window.addEventListener('resize', () => {
    let vh = window.outerHeight * 0.01
    document.documentElement.style.setProperty('--vh', `${vh}px`)
  })
} */


let vh = window.innerHeight * 0.01
  document.documentElement.style.setProperty('--vh', `${vh}px`)

  /* window.addEventListener('resize', () => {
    if(window.innerHeight > 500){
      let vh = window.innerHeight * 0.01
      document.documentElement.style.setProperty('--vh', `${vh}px`)
    }
  }) */

class AppLink extends HTMLElement {
  connectedCallback(){
    this.addEventListener('click', () => {
      window.metaApp.router.pushWithEvent(this.route)
    })
  }

  static get boundAttributes() {
    return ['route'];
  }

  attributeChangedCallback(attrName, oldValue, newValue) {
    this[attrName] = this.hasAttribute(attrName);
  }

  get route() {
    return this.getAttribute('route');
  }
  
  set route(route) {
    this.setAttribute('route', route)
  }
}

window.customElements.define('app-link', AppLink)


axios.interceptors.response.use(
  response => response,
  error => {
    if(error.response.status === 403){
      router.push('/not-logged-in')
    }
  }
)


Vue.config.productionTip = false

Config.getConfig().then((config) => {
  Vue.prototype.$eventBus = new Vue()
  Vue.prototype.$appInfo = config.appInfo
  Vue.prototype.$modules = config.modules
  Vue.prototype.$layout = config.layout
  Vue.prototype.$langs = config.langs
  Vue.prototype.$texts = config.texts
  Vue.prototype.$axios = axios

  const sharedStore = new SharedStore

  Vue.prototype.$sharedStore = sharedStore

  Config.setFont(config.style.fonts)

  Config.setColors(config.style.colors)

  const i18n = new VueI18n({
    locale: 'fr'
  })

  Vue.prototype.$sharedStore.set('locale', 'fr')

  Vue.prototype.$t = (sectionName) => {
    return Vue.prototype.$texts[i18n.locale][sectionName]
  }

  if ('serviceWorker' in navigator) {
    console.log("Will the service worker register?");
    navigator.serviceWorker.register('/service-worker.js')
      .then(function (reg) {
        console.log("Yes, it did.");
      }).catch(function (err) {
        console.log("No it didn't. This happened:", err)
      });
  }

  const appContext = new Vue({
    i18n,
    router,
    store,
    render: h => h(App)
  }).$mount('#app')

  router.pushWithEvent = (route) => {
    router.push(route)
    sharedStore.dispatchEvent('routeHasChanged')
  }

  

  Vue.prototype.$dialog = new Dialog(appContext);
  Vue.prototype.$modal = new Modal(appContext)
  Vue.prototype.$styleTag = document.createElement('style')
  document.head.appendChild(Vue.prototype.$styleTag)
  Vue.prototype.$scriptTag = document.createElement('script')
  document.head.appendChild(Vue.prototype.$scriptTag)


  sharedStore.addEventListener('routeHasChanged', () => {
    Vue.prototype.$scriptTag.innerHTML = ''
    Vue.prototype.$styleTag.innerHTML = ''
  })

  window.metaApp = {
    appInfo: Vue.prototype.$appInfo,
    langs: Vue.prototype.$langs,
    i18n: i18n,
    texts: Vue.prototype.$texts,
    sharedStore: Vue.prototype.$sharedStore,
    axios: Vue.prototype.$axios,
    router: router,
    dialog: Vue.prototype.$dialog,
    modal: Vue.prototype.$modal,
    scriptTag: Vue.prototype.$scriptTag,
    styleTag: Vue.prototype.$styleTag
  };

})
